// extracted by mini-css-extract-plugin
export var container = "_du-0";
export var content = "_du-3";
export var customerTitle = "_du-4";
export var empty = "_du-5";
export var gray = "_du-6";
export var header = "_du-7";
export var info = "_du-8";
export var loading = "_du-2";
export var loadingCard = "_du-9";
export var oneLine = "_du-a";
export var personName = "_du-e";
export var pillContainer = "_du-b";
export var selected = "_du-1";
export var text = "_du-c";
export var twoLines = "_du-d";
export var unread = "_du-f";
export var unreadIndicator = "_du-g";